// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__DnPRO","colMin":"styles_colMin__odHtQ","colCheckbox":"styles_colCheckbox__2OFH0"};